import toast from 'react-hot-toast';
import apiHandler from './apiHandler'; 

const IncompleteBooking = async (request) => {
  try {
    const response = await apiHandler({
      endpoint2: '/crsbookings/editIncompleteBooking',
      method: 'POST',
      data: request,
    });

    if (response?.response_code == 200) {
      return response; 
    } else {

      throw new Error(response.message || 'Failed to update booking');
    }
  } catch (error) {
    console.error("Error updating booking", error);
    throw error; 
  }
};

export default IncompleteBooking;